module.exports = __webpack_public_path__ + "media/images/porque/art-instant-purchase-89cca7ded9aae7f6d1bc5ff0d3c05637.svg";